<template>
  <v-row>
    <v-col cols="12">
      <!-- Actuaciones  -->
      <v-row align="center" justify="start" class="pl-5">
        <v-col cols="8" md="2">
          <v-text-field
            v-model="fechaIni"
            @input="getActive"
            height="46"
            outlined
            background-color="white"
            label="Introduzca fecha incial"
            placeholder="aaaa-mm-dd"
            hide-details
            dense
          />
        </v-col>
        <v-col cols="8" md="2">
          <v-text-field
            v-model="fechaFin"
            @input="getActive"
            height="46"
            outlined
            background-color="white"
            label="Introduzca fecha fin"
            placeholder="aaaa-mm-dd"
            dense
            hide-details
          />
        </v-col>
        <v-col cols="1" class="text-left">
          <v-btn v-if="!active" @click="reset" icon :disabled="filter">
            <v-img height="30" width="30" src="@/assets/filter-disabled.png" />
          </v-btn>
          <v-btn v-else @click="getSearch" icon>
            <v-img height="30" width="30" src="@/assets/filter.png" />
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="getActuaciones"
        hide-default-footer
        :items-per-page="getPaginacionActuaciones.registrosPagina"
        no-data-text="El registro no posee actuaciones registradas"
        class="elevation-1 caption"
        style="background: transparent"
        :loading="getStatus.loading"
        loading-text="Cargando... Por favor espere"
        :single-expand="singleExpand"
        show-expand
        item-key="idRegActuacion"
        :expanded.sync="expanded"
      >
        <!-- v-if="item.conDocumentos!==item.conDocumentos" -->
        <!-- @click="documentsDialog=true, gidActuacion=item.idRegActuacion" -->
        <template v-slot:[`item.data-table-expand`]="{ expand, isExpanded, item }">
          <v-icon
            v-if="item.conDocumentos"
            @click="documentosActuaciones(item.idRegActuacion)"
            aria-hidden="true"
            large
            color="primary"
            class="pr-1"
          >fas fa-file</v-icon>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <template>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Nombre</th>
                      <th class="text-left">File</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(doc, index) in item.documentos" :key="index">
                      <td>{{ doc.nombre }}</td>
                      <td>
                        <v-btn
                          text
                          class="primary--text text-none font-weight-bold"
                          @click="downloadFile(doc.idRegDocumento, doc.nombre)"
                        >
                          <v-icon
                            v-if="isLoading != doc.idRegDocumento"
                            aria-hidden="true"
                            large
                            color="primary"
                            class="pr-1"
                          >fas fa-file</v-icon>
                          <v-progress-circular
                            v-if="isLoading == doc.idRegDocumento"
                            indeterminate
                            color="primary"
                          ></v-progress-circular>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </template>
          </td>
        </template>
        <!-- <template v-slot:item.idConexion="{ item }">
          <template v-if="getActuaciones.length > 1">
            <v-icon small v-if="item.idConexion === 320">fas fa-hdd</v-icon>
            <v-icon small v-else-if="item.idConexion !== 320">fas fa-bars</v-icon>
          </template>
        </template>-->
        <template v-if="getStatus.loading" v-slot:progress>
          <v-progress-linear color="primary" :height="3" indeterminate></v-progress-linear>
        </template>
        <template v-if="getStatus.loading" v-slot:footer>
          <v-progress-linear color="primary" :height="3" indeterminate></v-progress-linear>
        </template>
      </v-data-table>
      <div class="mt-8 text-center">
        <Pagination />
      </div>
      <div class="text-center">

        <!-- <v-dialog
          v-model="documentsDialog"
          width="80%"
        > -->

        <!-- <v-dialog
          v-model="documentsDialog"
          width="80%"
        >
          <h1>Documentos de Actuación</h1>
          <ProccessDocuments :docsDeActuaciones="true" />
        </v-dialog> -->
        <v-dialog
          v-model="documentsDialog"
          class="mx-10"
        >
          <v-card class="pa-1">
            <!-- width="90%" -->
            <v-toolbar >
              <v-spacer></v-spacer>
              <v-toolbar-title class="text--primary font-weight-bold">
                Documentos de Actuación
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                icon 
                @click="documentsDialog=false"
              >
                <v-icon>
                  fas fa-times
                </v-icon>
              </v-btn>                
            </v-toolbar>
            <ProccessDocuments :docsDeActuaciones="true" class="ma-1"  />
          </v-card>
        </v-dialog>
      </div>      
    </v-col>
    <v-col class="text-center">
      <v-dialog v-model="show" width="500" id="docs-dialog" >
        <Notifier v-if="show && consulted" :message="message" @close="show = false" />
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>

import axios from "@/config/axios";
import { mapGetters } from "vuex";
import Pagination from "@/components/process/Pagination";
import Notifier from "../Notifier";
import mime from "mime";
import ProccessDocuments from './ProcessDocuments.vue'

export default {
  components: { Pagination, Notifier, ProccessDocuments },
  data: () => ({
    expanded: [],
    menu: false,
    menu1: false,
    show: false,
    documentsDialog: false,
    // // // gidActuacion: 0,
    fechaIni: "",
    fechaFin: "",
    active: true,
    filter: false,
    filteredLocally: false,
    filterLocal: [],
    file: "fas fa-paperclip",
    singleExpand: false,
    isLoading: "",
    headers: [
      {
        text: "Fecha de Actuación",
        value: "fechaActuacion",
        class:
          "grey--text text--darken-3 body-1 font-weight-bold blue-grey lighten-5",
        sortable: false,
      },
      {
        text: "Actuación",
        value: "actuacion",
        class:
          "grey--text text--darken-3 body-1 font-weight-bold blue-grey lighten-5",
        sortable: false,
      },
      {
        text: "Anotación",
        value: "anotacion",
        class:
          "grey--text text--darken-3 body-1 font-weight-bold blue-grey lighten-5",
        sortable: false,
      },
      {
        text: "Fecha inicia Término",
        value: "fechaInicial",
        class:
          "grey--text text--darken-3 body-1 font-weight-bold blue-grey lighten-5",
        sortable: false,
        width: 110,
      },
      {
        text: "Fecha finaliza Término",
        value: "fechaFinal",
        class:
          "grey--text text--darken-3 body-1 font-weight-bold blue-grey lighten-5",
        sortable: false,
        width: 110,
      },
      {
        text: "Fecha de Registro",
        value: "fechaRegistro",
        class:
          "grey--text text--darken-3 body-1 font-weight-bold blue-grey lighten-5",
        sortable: false,
        width: 110,
      },
      { text: "", value: "data-table-expand", class: "blue-grey lighten-5" },
    ],
  }),

  computed: {
    ...mapGetters("process", [
      "getPaginacionActuaciones",
      "getActuaciones",
      "getStatus",
      "getPaginaActualActuaciones",
      "getTab",
      "getDocumentos",
      "getIdProceso",
    ]),
  },

  watch: {
    getPaginaActualActuaciones(pagina) {
      this.$store.dispatch("process/detailsActuaciones", {
        id: this.getIdProceso,
        fechaIni: this.fechaIni,
        fechaFin: this.fechaFin,
        tab: this.getTab,
      });
    },
  },

  methods: {
    async setPagina() {
      await this.$store.dispatch("process/detailsActuaciones", {
        id: this.getIdProceso,
        fechaIni: this.fechaIni,
        fechaFin: this.fechaFin,
        tab: this.getTab,
      });
    },
    getActive() {
      this.active = true;
    },
    async getSearch() {
      if (this.active) {
        this.$store.dispatch("process/setPaginaActuaciones", 1);
        await this.$store.dispatch("process/detailsActuaciones", {
          id: this.getIdProceso,
          fechaIni: this.fechaIni,
          fechaFin: this.fechaFin,
          tab: this.getTab,
        });
        this.active = false;
        this.filter = false;
      }
    },
    reset() {
      this.fechaIni = "";
      this.fechaFin = "";
      this.filter = true;
      this.$store.dispatch("process/detailsActuaciones", {
        id: this.getIdProceso,
        tab: this.getTab,
      });
      this.$store.dispatch("process/setPaginaActuaciones", 1);
    },
    async documentosActuaciones(gidActuacion) {
      if(this.documentsDialog)
        this.documentsDialog=false
      else{
        
        await this.$store.dispatch("process/documentosActuaciones", gidActuacion);
        this.documentsDialog=true
      }
    },

    downloadFile(idDocumento, nameDocumento) {
      this.isLoading = idDocumento;

      axios({
        url: `/Descarga/DocumentoActuacion/${idDocumento}`,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          let ext = mime.getExtension(response.headers["content-type"]);
          let blob = new Blob([response.data]);
          let fileURL = window.URL.createObjectURL(blob);
          let fileLink = document.createElement("a");
          let nombre =
            ext == "bin" ? `${nameDocumento}.DOC` : `${nameDocumento}.${ext}`;

          fileLink.href = fileURL;
          fileLink.setAttribute("download", nombre);
          document.body.appendChild(fileLink);

          fileLink.click();
          this.isLoading = "";
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = "";
          this.consulted = true;
          this.show = true;
          this.message =
            "El documento solicitado no está disponible en este momento, por favor intente más tarde.";
        });
    },
  },
};
</script>
<style scoped>
  ::v-deep .v-icon.v-icon {
      font-size: 18px !important;
  }

  #docs-dialog{
    background: white !important;;
  }

</style>
